export const PLAN_CREATION_STEPS = Object.freeze({
  settings: 0,
  pricingAndProducts: 1,
  completed: 2,
} satisfies Record<string, number>);

export type PlanCreationStep = (typeof PLAN_CREATION_STEPS)[keyof typeof PLAN_CREATION_STEPS];
